import { Button, Modal } from "react-bootstrap";
import ButtonSpinner from "../ButtonSpinner/ButtonSpinner";

const ConfirmationModal = ({
  children,
  show,
  onHide,
  buttonPrimaryOnClick,
  buttonSecondaryOnClick,
  buttonPrimaryText,
  buttonSecondaryText,
  loading,
}) => {
  return (
    <Modal show={show} onHide={onHide} size="md-down" backdrop="static" keyboard={false}>
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={buttonSecondaryOnClick}>
          {buttonSecondaryText}
        </Button>
        <ButtonSpinner type="button" variant="primary" onClick={buttonPrimaryOnClick} isLoading={loading}>
          {buttonPrimaryText}
        </ButtonSpinner>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
